<div *ngIf="isOffer" class="offer__container">
  <div [ngClass]="hotelPreviewInfo.expiring? 'offer': 'offer'">
    <div [ngStyle]="hotelPreviewInfo.title.length > 40 ? {'margin-top':'-20px'} : {}"
      class="offer__title flex gap-05 jc-sb ai-c">
      <a (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title)"
        [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
        [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, hotelid: hotelPreviewInfo.id, children: this.resultsContainer.requestForSearch.children, requestId: isOffer ? this.resultsContainer.requestId : this.resultsContainer.requestId }">{{hotelPreviewInfo.title}}</a>

      <!-- Pricing -->
      <div class="flex">
        <!-- Offer Prices - Old & New -->
        <div class="price__container flex-col jc-c ai-end gap-01">
          <span class="price price--old price--desktop" *ngIf="hotelPreviewInfo.hasDiscount">{{
            hotelPreviewInfo.minDefaultPrice }}€ /night</span>
          <span class="price price--old price--mobile" *ngIf="hotelPreviewInfo.hasDiscount">{{
            hotelPreviewInfo.minDefaultPrice
            }}€</span>
          <div class="price price--new">
            <h6>{{ hotelPreviewInfo.minPrice }}€</h6>
            <span>/night</span>
          </div>
        </div>
        <!-- Offer Discount - Percentage Label -->
        <div *ngIf="hasRoomDiscount(hotelPreviewInfo.minDefaultPrice, hotelPreviewInfo.minPrice)"
          class="offer__discount">
          <h3>-{{getDiscount(days*hotelPreviewInfo.minPrice, days*hotelPreviewInfo.minDefaultPrice)}}%</h3>
        </div>
        <div *ngIf="!hasRoomDiscount(hotelPreviewInfo.minDefaultPrice, hotelPreviewInfo.minPrice)"
          class="offer__discount">
          <h3>+{{getOverPrice(days*hotelPreviewInfo.minPrice, days*hotelPreviewInfo.minDefaultPrice)}}%</h3>
        </div>
      </div>
    </div>

    <!-- Offer Image Carousel -->
    <div class="offer__image">
      <ngb-carousel [interval]="false" *ngIf="hotelPreviewInfo.pictures" (slide)="onSlide($event)">
        <ng-template ngbSlide="ngbSlide" *ngFor="let image of hotelPreviewInfo.pictures; let i = index" [id]="i">
          <div *ngIf="!isMobile()">
            <a target="_blank" (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' !offer')"
              *ngIf="!isOffer" [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
              [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, children: this.resultsContainer.requestForSearch.children, requestId: this.resultsContainer.requestId, hotelid: hotelPreviewInfo.id, or: true}">
              <img *ngIf="image.preloaded" [src]="image.pictureThumbnailUrl" alt="Image">
            </a>
            <a target="_blank" (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' offer')"
              *ngIf="isOffer" [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
              [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, children: this.resultsContainer.requestForSearch.children, requestId: isOffer ? this.resultsContainer.requestId : null}">
              <img *ngIf="image.preloaded" [src]="image.pictureThumbnailUrl" alt="Image">
            </a>
          </div>

          <div *ngIf="isMobile()">
            <a (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' !offer')" *ngIf="!isOffer"
              [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
              [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, children: this.resultsContainer.requestForSearch.children, requestId: this.resultsContainer.requestId, hotelid: hotelPreviewInfo.id, or: true}">
              <img *ngIf="image.preloaded" [src]="image.pictureThumbnailUrl" alt="Image">
            </a>
            <a (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' offer')" *ngIf="isOffer"
              [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
              [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, children: this.resultsContainer.requestForSearch.children, requestId: isOffer ? this.resultsContainer.requestId : null}">
              <img *ngIf="image.preloaded" [src]="image.pictureThumbnailUrl" alt="Image">
            </a>
          </div>
        </ng-template>
      </ngb-carousel>
    </div>


    <!-- Host's Offer Note -->
    <div *ngIf="hotelPreviewInfo.offerNote && hotelPreviewInfo.offerNote.text" class="note-results">
      <div class="note-results__host flex ai-c gap-05">
        <div class="note-results__avatar" [ngStyle]="hotelPreviewInfo.offerNote.image ? {'background-image':'url(' +
                                hotelPreviewInfo.offerNote.image + ')'} : {'background-image':'url(' + appLogo + ')'}">
        </div>
        <h4 class="note-results__title">The host,
          {{ hotelPreviewInfo.hotelier.name }}, has sent you a personal note!</h4>
      </div>
      <p *ngIf="hotelPreviewInfo.offerNote" class="note-results__body">
        {{hotelPreviewInfo.offerNote.text}}
      </p>
    </div>

    <div *ngIf="finalWishes && finalWishes.size > 0" class="wishes mt-4">
      <div class="flex ai-base jc-sb">
        <h4>Your host can fulfill
          <span *ngIf="finalWishes" class="wishes__count">{{ satWishes }} of your {{ finalWishes.size }}</span> wishes
        </h4>
      </div>
    </div>


    <!-- <div class="divider-horizontal"></div> -->


    <!-- TODO: copied the code from the property page to display cancellations but needs tweaking -->

    <!-- <div *ngIf="room.cancellationPolicy.hotelCancellationPolicyDaysCollection[0] &&
    cancellationUntil.get(i)" class="flex ai-c jc-sb">
      <span class="room-price__label --success-txt">
        Free Cancellation until
      </span>
      <span class="room-price__number --success-txt">{{ cancellationUntil.get(i) }}</span>
    </div>
    <div *ngIf="room.cancellationPolicy.freeCancellation" class="flex ai-c jc-sb">
      <span class="room-price__label --success-txt">
        Cancellation
      </span>
      <span class="room-price__number --success-txt">FREE</span>
    </div> -->


    <!-- <div class="divider-horizontal"></div> -->


    <!-- TODO: copied the code from the property page to display experiences but needs tweaking -->

    <!-- <ul class="modal__exp-list gap-5">
      <li *ngFor="let experience of room.experiences | slice:0:auto;let expIndex = index" class="modal__exp-item">

        <div class="modal__exp-content flex">

          <img *ngIf="experience.hasImage" class="modal__exp-img"
            [src]="backendRoot + '/webresources/frontend/entity.hoteloptionalextra/image/thumbnail/'+ experience.id"
            alt="" />

          <div class="flex-col w-100 gap-2">
            <div class="flex gap-1 ai-c mb-2">
              <h6 class="modal__h6">{{ experience.title }}</h6>
              <div *ngIf="experience.discount" class="modal__exp-discount">
                <span>{{experience.discount}} % off</span>
              </div>
            </div>

            <div class="modal__exp-price flex-col w-100"
              *ngIf="experience.surchargeUnit != null && experience.surchargeAmount != 0 && !experience.isFree">
              <div class="flex jc-sb ai-c mb-0">
                <span class="expPrice">
                  <span class="exp-price__new"
                    *ngIf="experience.surchargeUnit != null && experience.surchargeAmount != 0 && !experience.isFree">{{experience.surchargeAmount}}€</span>
                  <span *ngIf="experience.was && experience.discount"
                    class="exp-price__original">{{experience.was}}€</span>
                </span>
                <span class="selectOptions">
                  <select title="Select Quantity" class="modal__exp-select"
                    (change)="onExperienceSelection($event.target.value, experience, i, room.title)">
                    <option *ngFor="let item of getItemArray(30);let i = index" [value]="i">{{i}}
                    </option>
                  </select>
                </span>
              </div>
              <span class="modal__exp-surcharge">{{experience.surchargeUnit.surchargeUnit}}</span>
            </div>

            <div *ngIf="isMobile()" class="flex-col gap-1">
              <span class="modal__exp-free"
                *ngIf="experience.surchargeUnit == null || experience.surchargeAmount === 0 || experience.isFree">FREE</span>
              <p class="modal__exp-body" *ngIf="experience.description.length>120">
                {{experience.description | slice:0:120}}<span id="more-text"
                  *ngIf="!isExperienceDescriptionVisible(i,expIndex) && experience.description.length>120"
                  [ngClass]="isExperienceDescriptionVisible(i,expIndex)?'hidden-dots':'dots'">...</span><span
                  [ngClass]="isExperienceDescriptionVisible(i,expIndex)?'more':'hidden'"
                  *ngIf="isExperienceDescriptionVisible(i,expIndex)">{{experience.description |
                  slice:200:end}}</span>
              </p>
              <p class="modal__exp-body" *ngIf="experience.description.length<=120">
                {{experience.description}}
              </p>
              <a *ngIf="experience.description.length>120" (click)="readMore(i,expIndex)" class="modal__exp-toggle">Read
                {{!isExperienceDescriptionVisible(i,expIndex)? 'more':
                'less'}}</a>
            </div>

            <div *ngIf="!isMobile()" class="flex-col gap-1">
              <span class="modal__exp-free"
                *ngIf="experience.surchargeUnit == null || experience.surchargeAmount === 0 || experience.isFree">FREE</span>
              <p class="modal__exp-body">
                {{experience.description}}
              </p>
            </div>
          </div>
        </div>

      </li>
    </ul> -->

    <!-- Offer Info - Expiry Date -->
    <div class="offer__info mt-4 flex ai-c jc-sb gap-2">
      <div class="offer__expires" *ngIf="hotelPreviewInfo.expiring">
        <h4>Offer Available for:</h4>
        <div class="offer__time">
          <div class="flex gap-05">
            <div *ngIf="hotelPreviewInfo.expiring.days > 0" class="flex-col time">
              <h3>{{hotelPreviewInfo.expiring.days}}</h3>
              <span>days</span>
            </div>
            <div class="flex-col time">
              <h3>{{hotelPreviewInfo.expiring.hours}}</h3>
              <span>hours</span>
            </div>
            <div class="flex-col time">
              <h3>{{hotelPreviewInfo.expiring.minutes}}</h3>
              <span>minutes</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!isMobile() && !isOffer" class="exclusives row row-item">
        <div *ngIf="hotelPreviewInfo.experiencesSortByAPrice.length > 0" class="offer__exp">
          <h3>Experiences</h3>
          <span class="offer__no-exp" *ngIf="hotelPreviewInfo.experiencesSortByAPrice.length === 0">No experiences
            available
          </span>
          <ul class="experiences-list" [ngStyle]="isOffer ? {'margin-bottom':'0'} : {}">
            <li *ngFor="let experience of hotelPreviewInfo.experiencesSortByAPrice | slice:0:isOffer ? 1 : 2">
              <span *ngIf="experience.isFree" class="free-label">FREE</span>
              {{experience.title}}
            </li>
          </ul>
          <ul [ngClass]="show?'experiences-list additional':'experiences-list nothing'" id="addExp">
            <li
              *ngFor="let experience of hotelPreviewInfo.experiencesSortByAPrice | slice:isOffer ? 1: 2:hotelPreviewInfo.experiencesSortByAPrice.length">
              <span *ngIf="experience.isFree" class="free-label">FREE</span>
              {{experience.title}}
            </li>
          </ul>
        </div>

        <span *ngIf="hotelPreviewInfo.experiencesSortByAPrice.length > 2" (click)="toggleExperiences()"
          [ngClass]="!show?'viewMoreExperiences':'viewLessExperiences'">
        </span>
      </div>

      <!-- Desktop Offer Button -->
      <a *ngIf="!isMobile() && isOffer" class="offer__cta flex gap-05" target="_blank"
        (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' offer')"
        [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
        [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, hotelid: hotelPreviewInfo.id, children: this.resultsContainer.requestForSearch.children, requestId: isOffer ? this.resultsContainer.requestId : this.resultsContainer.requestId }">
        <div class="cta__text flex-col">
          <h3>View Offer</h3>
          <p>and other property details</p>
        </div>
        <div class="cta__icon">
          <img src="../../../../assets/img/icons/arrow-right-blue.svg" alt="Arrow right icon">
        </div>
      </a>

      <!-- Mobile Offer Button -->
      <a *ngIf="isMobile() && isOffer" class="offer__cta flex gap-05"
        (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' offer')"
        [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
        [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, hotelid: hotelPreviewInfo.id, children: this.resultsContainer.requestForSearch.children, requestId: isOffer ? this.resultsContainer.requestId : this.resultsContainer.requestId }">
        <div class="cta__text flex-col">
          <h3>View Offer</h3>
        </div>
        <div class="cta__icon">
          <img src="../../../../assets/img/icons/arrow-right-blue.svg" alt="Arrow right icon">
        </div>
      </a>

    </div>

  </div>
</div>


<!-- PROPERTY LIST STARTS HERE -->

<div *ngIf="!isOffer" class="property-list flex-col jc-sb">
  <div class="property-list__image">
    <ngb-carousel [interval]="false" *ngIf="hotelPreviewInfo.pictures" (slide)="onSlide($event)">
      <ng-template ngbSlide="ngbSlide" *ngFor="let image of hotelPreviewInfo.pictures; let i = index" [id]="i">
        <div *ngIf="!isMobile()">
          <a target="_blank" (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' !offer')"
            *ngIf="!isOffer" [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
            [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, children: this.resultsContainer.requestForSearch.children, requestId: this.resultsContainer.requestId, hotelid: hotelPreviewInfo.id, or: true}">
            <img *ngIf="image.preloaded" [src]="image.pictureThumbnailUrl" alt="Image">
          </a>
          <a target="_blank" (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' offer')" *ngIf="isOffer"
            [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
            [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, children: this.resultsContainer.requestForSearch.children, requestId: isOffer ? this.resultsContainer.requestId : null}">
            <img *ngIf="image.preloaded" [src]="image.pictureThumbnailUrl" alt="Image">
          </a>
        </div>

        <div *ngIf="isMobile()">
          <a (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' !offer')" *ngIf="!isOffer"
            [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
            [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, children: this.resultsContainer.requestForSearch.children, requestId: this.resultsContainer.requestId, hotelid: hotelPreviewInfo.id, or: true}">
            <img *ngIf="image.preloaded" [src]="image.pictureThumbnailUrl" alt="Image">
          </a>
          <a (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' offer')" *ngIf="isOffer"
            [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
            [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, children: this.resultsContainer.requestForSearch.children, requestId: isOffer ? this.resultsContainer.requestId : null}">
            <img *ngIf="image.preloaded" [src]="image.pictureThumbnailUrl" alt="Image">
          </a>
        </div>
      </ng-template>
    </ngb-carousel>
    <div class="property-list__price">
      <h3 class="new-price">{{ hotelPreviewInfo.minPrice }}€ /
        <h6>night</h6>
      </h3>
    </div>
  </div>

  <div class="property-list__desc flex-col">
    <div class="property-list__availability flex gap-05 ai-c flex-start">
      <h3>{{hotelPreviewInfo.title}}</h3>
      <div [ngStyle]="hotelPreviewInfo.isAvailable ?
              {'padding': '0rem 0.6rem 0 0.3rem',
              'width': '73px',
              'height': '17px',
              'position': 'relative',
              'border-radius': '100vh',
              'font-size': '0.65rem',
              'font-weight': '500',
              'color': 'rgb(90, 196, 68)',
              'border': '1px solid currentColor',
              'display': 'flex',
              'align-items': 'center'}
              :
              {'padding': '0rem 0.6rem 0 0.3rem',
              'width': '73px',
              'height': '17px',
              'position': 'relative',
              'border-radius': '100vh',
              'font-size': '0.65rem',
              'font-weight': '500',
              'color': '#777',
              'border': '1px solid currentColor'}">
        <span *ngIf="hotelPreviewInfo.isAvailable">
          <svg width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="5" cy="5" r="5" fill="#5AC444" />
          </svg>
          Available
        </span>
        <span *ngIf="!hotelPreviewInfo.isAvailable">
          Unavailable
        </span>
      </div>
    </div>
    <p>{{ hotelPreviewInfo.description | slice:0:120 }}...</p>
    <div class="flex gap-1">
      <a target="_blank" (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' offer')"
        [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
        [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, hotelid: hotelPreviewInfo.id, children: this.resultsContainer.requestForSearch.children, requestId: isOffer ? this.resultsContainer.requestId : this.resultsContainer.requestId }">Read
        more

        <svg class="arrow-right" width="8" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.126 1.971L6.08 6.41l-4.954 4.562" stroke="#2C6DA9" stroke-width="2" />
        </svg>
      </a>
    </div>
  </div>

  <!-- Desktop Property List Button -->
  <a *ngIf="!isMobile()" target="_blank" class="property-list__cta flex jc-sb"
    (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' offer')"
    [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
    [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, hotelid: hotelPreviewInfo.id, children: this.resultsContainer.requestForSearch.children, requestId: isOffer ? this.resultsContainer.requestId : this.resultsContainer.requestId }">
    <h3 class="cta__text">View Property</h3>
    <div class="cta__icon">
      <svg width="37" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <circle cx="18.663" cy="18.478" transform="rotate(-180 18.663 18.478)" fill="#2c6da9" r="14.318" />
          <path
            d="M18.756 36a18 18 0 100-36 18 18 0 000 36zM10.88 19.125a1.125 1.125 0 110-2.25h13.034l-4.83-4.829a1.127 1.127 0 111.592-1.592l6.75 6.75a1.128 1.128 0 01.245 1.227c-.057.137-.14.261-.245.366l-6.75 6.75a1.127 1.127 0 01-1.593-1.594l4.831-4.828H10.881z"
            fill="#fff" />
        </g>
        <defs>
          <clipPath id="clip0">
            <path fill="#fff" transform="rotate(-180 18.378 18)" d="M0 0h36v36H0z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </a>

  <!-- Μobile Property List Button -->
  <a *ngIf="isMobile()" class="property-list__cta flex jc-sb"
    (click)="angulartics2Track('clicked ' + hotelPreviewInfo.title + ' offer')"
    [routerLink]="['property', hotelPreviewInfo.title, hotelPreviewInfo.id]"
    [queryParams]="{ checkInDate: this.resultsContainer.requestForSearch.fromdate, checkOutDate: this.resultsContainer.requestForSearch.todate, adults: this.resultsContainer.requestForSearch.adults, hotelid: hotelPreviewInfo.id, children: this.resultsContainer.requestForSearch.children, requestId: isOffer ? this.resultsContainer.requestId : this.resultsContainer.requestId }">
    <h3 class="cta__text">View Property</h3>
    <div class="cta__icon">
      <svg width="37" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <circle cx="18.663" cy="18.478" transform="rotate(-180 18.663 18.478)" fill="#2c6da9" r="14.318" />
          <path
            d="M18.756 36a18 18 0 100-36 18 18 0 000 36zM10.88 19.125a1.125 1.125 0 110-2.25h13.034l-4.83-4.829a1.127 1.127 0 111.592-1.592l6.75 6.75a1.128 1.128 0 01.245 1.227c-.057.137-.14.261-.245.366l-6.75 6.75a1.127 1.127 0 01-1.593-1.594l4.831-4.828H10.881z"
            fill="#fff" />
        </g>
        <defs>
          <clipPath id="clip0">
            <path fill="#fff" transform="rotate(-180 18.378 18)" d="M0 0h36v36H0z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </a>
</div>